import { useStore } from '@/hooks/useStore';
import { scrollToTop } from '@/utils/utils';
import classNames from 'classnames';
import { observer } from 'mobx-react-lite';
import { useEffect, useState } from 'react';

interface ScrollToTopProps {
    isEndLayout?: boolean
}
export default observer(function ScrollToTop({ isEndLayout = false }: ScrollToTopProps) {
    // store
    const { uiStore: { hidePosTop, contentTop } } = useStore();

    // state
    const [isView, setIsView] = useState(false);
    const [isFit, setIsFit] = useState(false);

    // lifecycle
    useEffect(() => {
        const handleScroll = () => {
            const scrollTop = window.scrollY;
            const windowHeight = window.innerHeight;

            if (contentTop !== null) {
                setIsView(contentTop <= scrollTop + windowHeight / 2);
            } else {
                setIsView(scrollTop > 150);
            }

            if (hidePosTop !== null) {
                setIsFit(hidePosTop <= scrollTop + windowHeight);
            }
        };

        window.addEventListener('scroll', handleScroll);
        handleScroll(); // Kiểm tra trạng thái ban đầu

        return () => window.removeEventListener('scroll', handleScroll);
    }, [contentTop, hidePosTop]);

    return (
        <div
            onClick={() => scrollToTop()}
            className={classNames(
                'fixed z-50 right-[10px] bottom-[10px] rounded-full size-[min(80px,16vw)] bg-[rgba(38,36,35,0.9)] grid aspect-square place-content-center overflow-hidden cursor-pointer scroll-transition scroll-init',
                isView && 'scroll-view',
                isFit && 'scroll-fit'
            )}
        >
            <p className='flex items-center justify-center gap-2 text-[min(12px,3.2vw)] font-semibold text-white flex-col leading-[1]'>
                <svg className='w-[1.6em] fill-[#fafafa] aspect-[calc(1/0.5483)]' role='img'>
                    <use href='#icon-arrow'></use>
                </svg>
                <span>TOP</span>
            </p>
        </div>
    );
});
